<!--
   Created by qing on 2022/4/7 下午4:29
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__lark">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>

        <div class="choose-apply-list-container" v-if="current.value && current.value.length">
          <div
            class="choose-apply-item"
            v-for="(item, idx) in current.value"
            :key="item.approvalCode" @click="onClickApplyItem(item)">
            <div class="left" v-if="false">
              <img :src="item.img" alt="">
            </div>
            <div class="right">
              <div class="header">
                <div class="title">
                  {{item.title}}
                </div>
                <el-tag
                  size="mini"
                  :type="statusColorMap[item.status]">
                  {{statusMap[item.status]}}
                </el-tag>
              </div>
              <div class="footer">
                <div class="user">
                  <van-image
                    round
                    fit="cover"
                    width="20px"
                    height="20px"
                    error-icon="el-icon-user-solid"
                    :src="item.initiatorImg"
                  />
                  <span class="user-name">
                          {{item.initiatorName}}
                        </span>
                </div>
                <div>
                        <span>
                          发起时间
                        </span>
                  <span>
                          {{formatDate(item.startTime)}}
                        </span>
                </div>
              </div>
            </div>
            <div v-if="!isRead" class="end" @click="e => {e.stopPropagation()}">
              <i class="el-icon-close" @click="current.value.splice(idx, 1)"></i>
            </div>
          </div>
        </div>

        <div v-if="isRead && (!current.value || !current.value.length)">
          暂无内容
        </div>
        <div v-if="!isRead">
          <el-button type="text" icon="el-icon-plus" @click="addApply">添加审批</el-button>
          <el-button v-if="current.value && current.value.length" type="text" icon="el-icon-refresh" @click="refresh">刷新全部状态</el-button>
        </div>
      </template>

    </van-cell>
    <van-popup
      class="choose-apply-drawer"
      v-model="visible"
      :style="{ height: '90%', width: '100%' }"
      get-container="body"
      :closeable="false"
      safe-area-inset-bottom
      position="bottom">
      <div class="choose-apply-container">
        <div class="header">
          <div>
            请选择关联审批单
          </div>
          <van-icon name="cross" @click="visible = false"/>
        </div>
        <div class="choose-apply-wrapper">
          <van-tabs v-model="activeName" @click="handleClick">
            <van-tab title="待办" name="RUNNING"></van-tab>
            <van-tab title="已办" name="HANDLED"></van-tab>
            <van-tab title="抄送我" name="CC"></van-tab>
            <van-tab title="已发起" name="CREATE"></van-tab>
          </van-tabs>
          <div class="apply-list-container" v-loading="loading">
            <div>
              <van-dropdown-menu>
                <van-dropdown-item v-model="selectStatus" :options="statusOpts" @change="statusChange"/>
              </van-dropdown-menu>
            </div>

            <van-list
              class="apply-list-wrapper"
              v-model="loading"
              :finished="finished"
              :immediate-check="false"
              finished-text="没有更多了"
              @load="loadMore">

              <template v-if="applyList.length">
                <div
                  class="apply-item"
                  v-for="item in applyList"
                  :key="item.approvalCode">
                  <div class="left" @click="e => {e.stopPropagation()}">
                    <el-checkbox
                      v-model="item.select"
                      :true-label="1"
                      :false-label="0"
                      @change="val => itemSelect(val, item)"
                    ></el-checkbox>
                  </div>
                  <div class="right" @click="onClickApplyItem(item)">
                    <div class="header">
                      <div class="title">
                        {{item.title}}
                      </div>
                      <el-tag
                        size="mini"
                        :type="statusColorMap[item.status]">
                        {{statusMap[item.status]}}
                      </el-tag>
                    </div>
                    <div class="container">
                      <div class="value-item" v-for="value in item.valueList">
                        <span class="key">
                          {{value.name}}
                        </span>
                        :
                        <span>
                          {{value.value}}
                        </span>
                      </div>
                    </div>
                    <div class="footer">
                      <div class="user">
                        <van-image
                          round
                          fit="cover"
                          width="20px"
                          height="20px"
                          error-icon="el-icon-user-solid"
                          :src="item.initiatorImg"
                        />
                        <span>
                          {{item.initiatorName}}
                        </span>
                      </div>
                      <div>
                        <span>
                          发起时间
                        </span>
                        <span>
                          {{formatDate(item.startTime)}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div
                v-if="!loading && !applyList.length"
                class="empty-background__container"
                style="height: calc(100% - 40px); background: url('/form/fetch/image?id=389025983828590593.png') no-repeat center/auto">
              </div>
            </van-list>
          </div>
        </div>
        <div class="choose-apply-footer">
          <el-button @click="visible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="detailVisible"
      :style="{ height: '90%', width: '100%' }"
      get-container="body"
      :closeable="false"
      safe-area-inset-bottom
      position="bottom">
      <iframe
        :src="detailSrc"
        width="100%"
        height="100%"
        frameborder="0">
      </iframe>
    </van-popup>
  </div>

</template>

<script>
  import {current} from './mixin'
  import {accurateFormatDate} from "../../../assets/js/Untis";

  export default {
    mixins: [current],
    data() {
      return {
        visible: false,
        detailVisible: false,
        activeName: 'RUNNING',
        showDeleteHandler: false,
        statusOpts: [
          {text: '全部状态', value: 'ALL'},
          {text: '审批中', value: 'PENDING'},
          {text: '已通过', value: 'APPROVED'},
          {text: '已拒绝', value: 'REJECTED'},
          {text: '已撤销', value: 'CANCELED'}
        ],
        statusMap: {
          'APPROVED': '已通过',
          'REJECTED': '已拒绝',
          'CANCELED': '已撤销',
          'PENDING': '审批中',
          'DELETED': '已删除',
          'ALL': '全部状态'
        },
        statusColorMap: {
          'APPROVED': 'success',
          'REJECTED': 'danger',
          'CANCELED': 'warning',
          'DELETED': 'info',
          'PENDING': '',
        },
        applyList: [],
        selectStatus: 'ALL',
        detailSrc: '',

        loading: false,
        finished: true,
        pageInfo: {
          pageToken: '',
          hasMore: 'YES'
        }
      }
    },
    created() {
    },
    methods: {
      // 时间转换方法
      formatDate(d) {
        return accurateFormatDate(d)
      },
      addApply() {
        this.applyList.splice(0, this.applyList.length)
        this.pageInfo.pageToken = ''
        this.fetchData()
        this.visible = true
      },
      statusChange() {

        this.applyList.splice(0, this.applyList.length)
        this.pageInfo.pageToken = ''
        this.fetchData()
      },
      confirm() {
        this.current.value.splice(0, this.current.value.length)
        this.applyList.forEach(item => {
          if (item.select) {
            this.current.value.push(item)
          }
        })
        this.visible = false
        this.controlChange()
      },
      itemSelect(val, item) {
        if (this.current.relateInstanceType === 'ONE') {
          if (val) {
            this.applyList.forEach(apply => {
              if (apply.instanceCode !== item.instanceCode) {
                apply.select = 0
              }
            })
          }
        }
      },
      handleClick(name, title) {
        console.log('handleClick', name, title)
        this.applyList.splice(0, this.applyList.length)
        this.pageInfo.pageToken = ''
        this.fetchData()
      },
      onClickApplyItem(item) {
        const aEle = document.createElement('a')
        aEle.href = item.urls.mobile
        aEle.target = '_blank'
        aEle.click()
      },
      loadMore() {
        this.loading = true
        const formSet = this.current.root
        this.$store.dispatch('actionFetchLarkApplyDataList', {
          appId: formSet.appId,
          formId: formSet.formId,
          fieldId: this.current.dataId,
          pageToken: this.pageInfo.pageToken,
          processStatus: this.selectStatus,
          tabType: this.activeName
        }).then(res => {
          this.applyList.push(...res.dataList)

          this.applyList.forEach(item => {
            const apply = this.current.value.filter(a => a.instanceCode === item.instanceCode)[0]
            if (apply) {
              this.$set(item, 'select', 1)
            } else {
              this.$set(item, 'select', 0)
            }
          })
          this.finished = res.hasMore === 'NO'
          this.pageInfo.pageToken = res.pageToken
          this.pageInfo.hasMore = res.hasMore
        }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },
      fetchData() {
        this.loading = true
        const formSet = this.current.root
        this.$store.dispatch('actionFetchLarkApplyDataList', {
          appId: formSet.appId,
          formId: formSet.formId,
          fieldId: this.current.dataId,
          pageToken: this.pageInfo.pageToken,
          processStatus: this.selectStatus,
          tabType: this.activeName
        }).then(res => {
          this.applyList.splice(0, this.applyList.length, ...res.dataList)

          this.applyList.forEach(item => {
            const apply = this.current.value.filter(a => a.instanceCode === item.instanceCode)[0]
            if (apply) {
              this.$set(item, 'select', 1)
            } else {
              this.$set(item, 'select', 0)
            }
          })
          this.finished = res.hasMore === 'NO'
          this.pageInfo.pageToken = res.pageToken
          this.pageInfo.hasMore = res.hasMore
        }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },

      refresh() {
        const formSet = this.current.root
        this.$store.dispatch('actionFetchLarkApplyDataRefresh', {
          appId: formSet.appId,
          formId: formSet.formId,
          fieldId: this.current.dataId,
          data: formSet.getValues()
        }).then(res => {
          this.current.value = res[this.current.dataId]
          this.controlChange()
        }).catch(console.error)
      }
    },
  }
</script>

<style lang="less">

  .ry-form__lark {

    .van-cell__title {
      width: 100%;

      .van-cell__label {
        width: 100%;
      }
    }

    .choose-apply-list-container {

      .choose-apply-item {
        display: flex;
        padding: 6px;
        border-radius: 10px;
        border: 1px solid #e6e6e6;
        margin-bottom: 10px;
        width: 100%;
        cursor: pointer;

        .left {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4px;
          margin-right: 5px;

          img {
            width: 40px;
            height: 40px;
            border-radius: 6px;
          }
        }

        .right {
          width: calc(100% - 30px);

          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 24px;

            .title {
              font-size: 16px;
              font-weight: 500;
            }
          }

          .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #4b4b4b;
            height: 24px;

            .user {
              display: flex;
              align-items: center;
              font-size: 12px;

              .van-image {
                margin-right: 6px;
                min-width: 20px;
              }
            }
          }
        }

        .end {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px;
          margin-left: 5px;

          i {
            cursor: pointer;
            font-size: 18px;
          }
        }
      }
    }
  }

  .choose-apply-drawer {

    .el-drawer__body {
      background-color: #fafafa;
    }

    .choose-apply-container {
      width: 100%;
      height: 100%;
      background-color: #fafafa;

      > .header {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background-color: #FFFFFF;
        border-bottom: 1px solid #e6e6e6;
      }

      .ac-header__fixation-batch {
        width: fit-content;
      }

      .choose-apply-wrapper {
        height: calc(100% - 100px);
        width: 100%;
        border-radius: 5px;

        .el-tabs__header {
          padding: 0 20px;
        }

        .apply-list-container {
          height: calc(100% - 44px);

          .van-dropdown-menu__bar {
            height: 34px;

            .van-ellipsis {
              font-size: 13px;
            }
          }

          .apply-list-wrapper {
            height: calc(100% - 34px);
            overflow: auto;
            padding-top: 5px;

            .apply-item {
              display: flex;
              padding: 5px 10px;

              .left {
                display: flex;
                justify-content: center;
                align-items: center;

                .el-checkbox {
                  margin-right: 10px;
                }
              }

              .right {
                width: calc(100% - 20px);
                border-radius: 4px;
                border: 1px solid #e6e6e6;
                padding: 10px;
                background-color: #FFFFFF;

                .header {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 10px;

                  .title {
                    font-size: 16px;
                    font-weight: 500;
                  }
                }

                .container {

                  .value-item {
                    margin-bottom: 6px;
                    font-size: 14px;

                    .key {
                      color: #4e5660;
                    }

                    .value {
                      line-height: 20px;
                    }
                  }
                }

                .footer {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-size: 12px;
                  color: #4b4b4b;

                  .user {
                    display: flex;
                    align-items: center;
                    font-size: 14px;

                    .van-image {
                      margin-right: 6px;
                      min-width: 20px;
                    }
                  }
                }
              }
            }
          }
        }

      }

      .choose-apply-footer {
        height: 60px;
        display: flex;
        justify-content: flex-end;
        background-color: #FFFFFF;
        padding: 10px;
      }
    }
  }
</style>